import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  AnnouncementService,
  ViewAnnouncementModel,
} from 'src/app/announcement/shared/services/announcement.service';
import * as sharedAnnouncementService from 'src/app/shared/services/announcement.service';
import * as AnnouncementDetailsActions from './actions';
import {
  mergeMap,
  catchError,
  map,
  tap,
  withLatestFrom,
  filter,
  switchMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslitService } from 'src/app/shared/services/translit.service';
import { Router, UrlTree } from '@angular/router';
import { Location } from '@angular/common';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../state';
import { SsrService } from '@hrra/core';
import { selectAnnViewCountIgnorePeriod, selectCurrentWebsite } from '../../selectors';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { BannerService } from 'src/app/banner/shared/services/banner.service';
import { AuthService } from 'src/app/core/auth.service';
import { AnnouncementViewEvent } from 'src/app/announcement/shared/models/announcement-details-model';

@Injectable()
export class AnnouncementDetailsEffects{

    loadAnnouncementDetails$ = createEffect(() => this.actions$.pipe(
        ofType(AnnouncementDetailsActions.loadAnnouncementDetails),
        mergeMap(action => this.announcementService.getAnnouncement(action.payload.announcementId)
        .pipe(
            map(response => AnnouncementDetailsActions.loadAnnouncementDetailsSuccess({payload: response.data})),
            tap(d => {
                if(!d.payload.announcement.expired && (action.payload.urlTitle == null || action.payload.urlTitle != this.translit.getUrlFriendlyString(d.payload.announcement.title))){

                  console.log('AnnouncementDetailsEffects: redirecting to correct URL for announcement', d.payload.announcement.announcementId, 'with title: ', d.payload.announcement.title, 'and urlTile: ', this.translit.getUrlFriendlyString(d.payload.announcement.title));

                  let redirectTarget:UrlTree = null;

                  if(action.payload.nav != null){
                        redirectTarget = this.router.createUrlTree(['/announcement', d.payload.announcement.announcementId, this.translit.getUrlFriendlyString(d.payload.announcement.title)], { queryParams: { nav: action.payload.nav }});
                    }
                    else {
                        redirectTarget = this.router.createUrlTree(['/announcement', d.payload.announcement.announcementId, this.translit.getUrlFriendlyString(d.payload.announcement.title)]);
                    }

                  if(this.ssrService.isPlatformServer()){
                    const redirectUrl = this.router.serializeUrl(redirectTarget);
                    const absoluteUrl = this.location.prepareExternalUrl(redirectUrl);
                    this.ssrService.setStatusMovedPermanently(absoluteUrl);
                  }
                  else if(this.ssrService.isPlatformBrowser()){
                    this.router.navigateByUrl(redirectTarget);
                  }
                    // if(action.payload.nav != null){
                    //     this.router.navigate(['/announcement', d.payload.announcement.announcementId, this.translit.getUrlFriendlyString(d.payload.announcement.title)], { queryParams: { nav: action.payload.nav }});
                    // }
                    // else {
                    //     this.router.navigate(['/announcement', d.payload.announcement.announcementId, this.translit.getUrlFriendlyString(d.payload.announcement.title)]);
                    // }
                }
            }),
            filter(
              (d) =>
                !(
                  !d.payload.announcement.expired &&
                  (action.payload.urlTitle == null ||
                    action.payload.urlTitle !=
                      this.translit.getUrlFriendlyString(
                        d.payload.announcement.title
                      ))
                )
            ),
            catchError((response) =>
              of(
                AnnouncementDetailsActions.loadAnnouncementDetailsFail({
                  payload: response.error,
                })
              )
            )
          )
      )
    )
  );

    loadAnnouncementDetailsSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(AnnouncementDetailsActions.loadAnnouncementDetailsSuccess),
        filter(d  => this.ssrService.isPlatformBrowser()),
        switchMap(action => this.store.select(selectCurrentWebsite).pipe(
          filter((providerId) => providerId != null),
          map(providerId => ({ action, providerId }))
      )),
        map(({action,providerId}) => AnnouncementDetailsActions.sendAnnouncementViewToAnalytic({payload: {announcement: action.payload.announcement, providerWebsiteId:providerId.providerWebsiteId}}))
    ));

 sendAnnouncementViewToAnalytic$ = createEffect(() => 
  this.actions$.pipe(
    ofType(AnnouncementDetailsActions.sendAnnouncementViewToAnalytic),
    tap(action => {
      const announcementAnalytic: AnnouncementViewEvent = {
        announcementId: action.payload.announcement.announcementId,
        announcementStatId: action.payload.announcement.announcementStatId,
        announcementRenewalStatId: action.payload.announcement.announcementRenewalStatId,
        providerWebsiteId: action.payload.providerWebsiteId,
        userId: this.authService.getUserId(),
        isAnonymous: !this.authService.isSignedIn(),
        isUnique: this.announcementService.isAnnouncementViewCountable(
          action.payload.announcement.announcementId
        )
      };
      
      this.announcementService.sendAnnouncementViewToAnalytic(announcementAnalytic);
    }),
    map(action => AnnouncementDetailsActions.viewAnnouncement({
      payload: {
        announcementId: action.payload.announcement.announcementId,
        isUniqueView: this.announcementService.isAnnouncementViewCountable(
          action.payload.announcement.announcementId
        )
      }
    })),
    catchError(response => {
      return of(AnnouncementDetailsActions.sendAnnouncementViewToAnalyticFail({
        payload: response.error
      }));
    })
  ),
  { dispatch: true }
);

  getAnnouncementViewCounts$ = createEffect(() =>
    this.actions$.pipe(
        ofType(AnnouncementDetailsActions.getAnnouncementViewCounts),
        mergeMap(action => this.announcementService.getAnnouncementViewCount(action.payload.announcementId)
        .pipe(
            map(response => AnnouncementDetailsActions.getAnnouncementViewCountsSuccess({ payload: { announcementStats: response.data } })),
            catchError(response => of(AnnouncementDetailsActions.getAnnouncementViewCountsFail({ payload: response.error })))
        ))
    ));

viewAnnouncement$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AnnouncementDetailsActions.viewAnnouncement),
    withLatestFrom(this.store.pipe(select(selectAnnViewCountIgnorePeriod))),
    tap(([action, ignorePeriod]) => {
      const currentDate = new Date();
      const viewData: ViewAnnouncementModel = {
        announcementId: action.payload.announcementId,
        expireDate: new Date(currentDate.getTime() + ignorePeriod * 60000),
      };
      this.announcementService.addAnnouncementView(viewData);
    }),
    map(() => AnnouncementDetailsActions.viewAnnouncementSuccess())
  )
);

  searchAnnouncements$ = createEffect(() =>
    this.actions$.pipe(
        ofType(AnnouncementDetailsActions.loadNavigationIds),
        mergeMap(action => this.sharedAnnouncementService.searchAnnouncements(action.payload.filter)
        .pipe(
            map(response => AnnouncementDetailsActions.loadNavigationIdsSuccess({ payload: {announcementIdsWithTitles: response.data.announcements.items.map(e => {return {announcementId:e.announcementId,announcementTitle:e.title}}), start: action.payload.start} })),
            catchError(response => of(AnnouncementDetailsActions.loadNavigationIdsFail({ payload: response.error })))
        ))
    ));

  getAnnDetailsPageBannerList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AnnouncementDetailsActions.getAnnDetailsPageBannerList),
      mergeMap((action) =>
        this.bannerService
          .getBannerList(action.payload.targetId, action.payload.bannerHeadId)
          .pipe(
            map((response) =>
              AnnouncementDetailsActions.getAnnDetailsPageBannerListSuccess({
                payload: response.data,
              })
            ),
            catchError((error) =>
              of(
                AnnouncementDetailsActions.getAnnDetailsPageBannerListFailed({
                  payload: error.error,
                })
              )
            )
          )
      )
    )
  );
  apply$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AnnouncementDetailsActions.apply),
      mergeMap((action) =>
        this.announcementService.apply(action.payload.announcementId).pipe(
          map((response) =>
            AnnouncementDetailsActions.applySuccess({
              payload: { announcement: response.data },
            })
          ),
          catchError((response) =>
            of(
              AnnouncementDetailsActions.applyFailed({
                payload: response.error,
              })
            )
          )
        )
      )
    )
  );

  applyFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AnnouncementDetailsActions.applyFailed),
        tap((d) => {
          this.dialogService.getApplyFailedDialog(d.payload.errorCode);
        })
      ),
    { dispatch: false }
  );


    constructor(private actions$: Actions, 
                private announcementService: AnnouncementService, 
                private sharedAnnouncementService: sharedAnnouncementService.AnnouncementService, 
                private translit: TranslitService, 
                private router: Router,
                private location: Location,
                private bannerService: BannerService,
                private store: Store<AppState>,
                private ssrService: SsrService,
                private dialogService: DialogService,
                private authService: AuthService,
                private translate: TranslateService){}
}
